import { ChangeEvent, useEffect, useState } from 'react';
import Input from 'components/UI/Form/Input';

interface EditableCellProps {
  value: string;
  row: { index: any };
  column: { id: any };
  updateTableData: (index: number, id: number, value: string) => void;
  editableRowIndex: number;
}

const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateTableData, // This is a custom function that we supplied to our table instance
  editableRowIndex, // index of the row we requested for editing
}: EditableCellProps) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateTableData(index, id, value);
  };

  // If the initialValue is changed externally, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return index === editableRowIndex ? (
    <Input
      type='text'
      name={id}
      value={value}
      placeholder='e.g. Sage Office'
      changed={onChange}
      onBlur={onBlur}
      required
    />
  ) : (
    <p>{value}</p>
  );
};

export default EditableCell;
